import React, { useState, useEffect } from 'react';
import api from '../api';
import axios from 'axios';
import DashboardNav from './DashboardNav';
import LoadingSpinner from './LoadingSpinner';
import './SOSAlerts.css';

const SOSAlerts = () => {
  const [alerts, setAlerts] = useState([]);
  const [filterDate, setFilterDate] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchSOSAlerts = async () => {
      try {
        setIsLoading(true);
        setError('');
        const token = localStorage.getItem('token');
        const res = await api.get('/sos-alerts', {
          headers: {
            'x-auth-token': token,
          },
          params: { date: filterDate }, // Pass filter date as query parameter
        });
        setAlerts(res.data);
      } catch (err) {
        console.error('Error fetching SOS alerts:', err.response ? err.response.data : err.message);
        setError('Failed to load SOS alerts. Please try again.');
      } finally {
        setIsLoading(false);
      }
    };
    fetchSOSAlerts();
  }, [filterDate]); // Re-fetch when filterDate changes

  const handleDateChange = (e) => {
    setFilterDate(e.target.value);
  };

  return (
    <div className="sos-alerts-container">
      <header className="sos-alerts-header">
        <h1>SOS Alerts</h1>
        <DashboardNav />
      </header>
      <div className="filters">
        <div className="filter-group">
          <label htmlFor="date-picker">Date:</label>
          <input
            type="date"
            id="date-picker"
            name="date"
            value={filterDate}
            onChange={handleDateChange}
          />
        </div>
      </div>
      
      {error && (
        <div className="error-message">
          <p>{error}</p>
          <button onClick={() => window.location.reload()}>Retry</button>
        </div>
      )}
      
      <div className="alerts-list">
        {isLoading ? (
          <LoadingSpinner size="medium" message="Loading SOS alerts..." />
        ) : (
          <>
            <table className="data-table">
              <thead>
                <tr>
                  <th>Time</th>
                  <th>Bus</th>
                  <th>Message</th>
                </tr>
              </thead>
              <tbody>
                {alerts.length > 0 ? (
                  alerts.map((alert) => (
                    <tr key={alert._id}>
                      <td>{new Date(alert.timestamp).toLocaleString()}</td>
                      <td>{alert.bus ? alert.bus.busNumber : 'N/A'}</td>
                      <td>{alert.message}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" style={{ textAlign: 'center', padding: '20px' }}>
                      No SOS alerts for the selected date.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </>
        )}
      </div>
    </div>
  );
};

export default SOSAlerts;
